import AnnualDataQualityMeasurementIntegrity from "./AnnualDataQualityMeasurementIntegrity";

const AnnualServiceLevelWaitingTimeCompliance = (props) => (
  <AnnualDataQualityMeasurementIntegrity
    {...props}
    title="Annual Service-Level and Waiting-Time Compliance"
    description="Annual compliance envelope for waiting-time targets, SLA pass rates, breach concentration, and raw-sample confidence warnings."
    emptyTableText="No annual SLA compliance tables were supplied."
  />
);

export default AnnualServiceLevelWaitingTimeCompliance;
